(function(){
	var specificUser={
		"道姐":["url('//img.gyyxcdn.cn/dao/user/images/daojieBgUser.jpg') no-repeat center top","光宇游戏","问道","道姐","每分每秒都在活跃中","已经数不清楚了╮(╯_╰)╭","daojiebq","好心值已经爆棚啦~"],
		"公告":["","光宇游戏","问道","官方公告","有公告的时候冒泡~","公告需要道行吗？","gonggaobq","公告需要好心值吗？"]
	}

	/**
	 * @interface getUserServerUrl 获取用户区服信息
	 */
	var getUserServerUrl = '/user/profile/info';
	/**
	 * @interface getUserActionInfoUrl 获取账号活动信息
	 */
	var getUserActionInfoUrl = '/user/action/infos';
	/**
	 * @interface prizeUrl 抽奖接口
	 */
	var prizeUrl = '/user/action/lottery';
	/**
	 * @interface getAddressUrl 获取地址接口,get方式
	 */
	var getAddressUrl = '/user/action/myAddress';
	/**
	 * @interface postAddressUrl 提交地址接口,post方式
	 */
	var postAddressUrl = '/user/action/myAddress';


	function DaoActions(){
		//constructor
	}
	DaoActions.prototype = {
		init:function(){
			var _this = this;

			_this.popFn($('#actionMyPrizeList'),'init');
			_this.popFn($('#actionRealPrize'),'init');
			_this.popFn($('#actionText'),'init',{
				width:'409px',
				height:'189px'
			});

			_this.getUserServerFn();
			_this.logOutFn();
			_this.getUserActionInfoFn();
			_this.getMyPrizeListFn();
			_this.lotteryFn();

			_this.myAddressSubFn();

			$('.js_actionPopCloseBtn').click(function(){
				_this.popFn($('#actionText'),'close');
			});
		},
		/**
		 * @function getUserServerFn 获取用户区服信息
		 */
		getUserServerFn:function(){
			//跳转绑定角色页面
			$('.js_bindRole').attr('href',"/user/member/?source="+encodeURIComponent(window.location.href));

			$.ajax({
				url:getUserServerUrl,
				type:'get',
				dataType:'json',
				data:{
					r:Math.random()
				},
				success:function(d){
					if(d.status=="success"){
						$('.js_actionNeedLogin').hide();
						$('.js_actionUserInfo').show();

						var userNN=d.data.nickname;
						var userGams=specificUser[userNN];

						$('.js_actionNickName').html(userNN);

						if(userGams){
							$('.js_noRoleInfo').hide();
							$('.js_serverInfo').show();
							$('.js_serverInfo').html(userGams[1]+'|'+userGams[2]+'|'+userGams[3]);
						}else{
							if(d.data.roleName){

								$('.js_noRoleInfo').hide();
								$('.js_serverInfo').show();
								$('.js_serverInfo').html(d.data.areaName+'|'+d.data.serverName+'|'+d.data.roleName);
							}else{
								$('.js_noRoleInfo').show();
								$('.js_serverInfo').hide();
							}
						}
					}else{
						$(document).errorDataOperateFn(d,null,{
							loginErrorFn:function(){
								$('.js_actionNeedLogin').show();
								$('.js_actionUserInfo').hide();
							}
						}); 
					}
				}
			});
		},
		/**
		 * @function getUserActionInfoFn 获取用户活动信息
		 */
		getUserActionInfoFn:function(){
			var _this = this;
			$.ajax({
				url:getUserActionInfoUrl,
				type:'get',
				dataType:'json',
				data:{
					r:Math.random()
				},
				success:function(d){
					//活动起止时间
					var startTimesObj = _this.formatTimeFn(d.data.hdInfo.hdStart);
					var endTimesObj = _this.formatTimeFn(d.data.hdInfo.hdEnd);

					var startTimesStr = startTimesObj.year+'.'+startTimesObj.month+'.'+startTimesObj.day+'  '+startTimesObj.hour+':'+startTimesObj.minute;
					var endTimesStr = endTimesObj.year+'.'+endTimesObj.month+'.'+endTimesObj.day+'  '+endTimesObj.hour+':'+endTimesObj.minute;
					$('.js_actionTime').html(startTimesStr+' - '+endTimesStr);

					if(d.status=="success"){
						//剩余抽奖次数
						$('.js_actionPrizeNumber').html(d.data.leftTimes);
						//状态中奖列表
						var prizeListStr = '';
						if(d.data.userWins.length===0){
							prizeListStr+='<li><label class="name">暂无数据</label></li>';
						}else{
							for(var i=0,l=d.data.userWins.length;i<l;i++){
								var dates = _this.formatTimeFn(d.data.userWins[i].winningTime); 
								prizeListStr+='<li>'+
												'<label class="name">'+d.data.userWins[i].prizeName+'</label>'+
												'<span class="time">'+dates.year+'.'+dates.month+'.'+dates.day+'</span>'+
												'</li>';
							} 
						}
						$('.js_ActionUserPrizeList').html(prizeListStr);

					}else{
						$(document).errorDataOperateFn(d,null,{
							loginErrorFn:function(){
								$('.js_actionNeedLogin').show();
								$('.js_actionUserInfo').hide();
							}
						}); 
					}
				}
			});
		},
		/**
		 * @function getMyPrizeListFn 获取我的中奖列表
		 */
		getMyPrizeListFn:function(){
			var _this = this;
			$('.js_actionMyPrizeList').click(function(){
				_this.popFn($('#actionMyPrizeList'),'open');
			});
		},
		/**
		 * @function lotteryFn 抽奖
		 */
		lotteryFn:function(){
			var _this = this;
            $("#rotate").click(function(){
                var $this = $(this);

                if($this.attr("data-status")=="go"){
					$.ajax({
						url:prizeUrl,
						type:"post",
						dataType:"json",
						data:{
							r:Math.random()
						},
						beforeSend:function(){
							$this.attr("data-status","stop");
						},
						success:function(d){
							
							if(d.status==='success'){

								_this.getUserActionInfoFn();
		
								//转盘调用
								rotateModule.init({
									rotateObj:$('#rotate'), //旋转对象
									angles:45*(parseInt(d.data.prizeFlag)-1),  //奖品角度-顺时针旋转
									callbackFn:function(){ //转完后执行函数
		
										$this.attr('data-status','go');
		
										if(d.data.prizeType==='virtual'||d.data.prizeType==='thanks'){   //虚拟奖弹层
											$('.js_actionTip').html('恭喜中奖('+d.data.prizeName+')');
											_this.popFn($('#actionText'),'open');
		
										}else if(d.data.prizeType==='real'){  //实物奖弹层
		
											
											$('.js_actionRealTitle').html('恭喜中奖('+d.data.prizeName+')');
											_this.getAddressFn();
											_this.popFn($('#actionRealPrize'),'open');
		
										}
		
		
									}
								});
		
							}else{

								$this.attr('data-status','go');
		
								if(d.status==='no-chance'){
									_this.getUserActionInfoFn();
									$('.js_actionTip').html('您今日抽奖机会已用完');
									_this.popFn($('#actionText'),'open');
		
								}else if(d.status==='no-chance-can-get'){
									_this.getUserActionInfoFn();
									$('.js_actionTip').html('采纳心仪答案就能获得抽奖机会哦！');
									_this.popFn($('#actionText'),'open');
		
								}else{
									$(document).errorDataOperateFn(d,null,{
										loginErrorFn:function(){
											$('.js_actionNeedLogin').show();
											$('.js_actionUserInfo').hide();
										}
									}); 
								}
							}

						},
						error:function(){
							$this.attr('data-status','go');
						}
					});
                }
                    
            });
		},
		/**
		 * @function getAddressFn 获取地址
		 */
		getAddressFn:function(){
			var nameObj = $('.js_actionNameInput');
            var phoneObj = $('.js_actionPhoneInput');
            var addressObj = $('.js_actionAddressInput');

            nameObj.val('');
            phoneObj.val('');
			addressObj.val('');
			$('#actionRealPrize .js_actionFormError').html('');

			$.ajax({
				url:getAddressUrl,
				type:'get',
				dataType:'json',
				data:{
					r:Math.random()
				},
				success:function(d){
					if(d.status==='success'&&d.data){
                        nameObj.val(d.data.realName);
                        phoneObj.val(d.data.phone);
                        addressObj.val(d.data.address);
                    }
				}
			});
		},
		/**
         * @function validateFormFn 验证表单
         */
        validateFormFn:function(){
            var flag = true;
            var nameObj = $('.js_actionNameInput');
            var phoneObj = $('.js_actionPhoneInput');
            var addressObj = $('.js_actionAddressInput');

            var name = $.trim(nameObj.val());
            var phone = $.trim(phoneObj.val());
            var address = $.trim(addressObj.val());

			var expPhone = new RegExp('^1[0-9]{10}$');
			
			var expText = new RegExp('^[A-Z0-9a-z \u4E00-\u9FA5\uF900-\uFA2D]{1,}$');

			var formErrorTipObj = $('#actionRealPrize .js_actionFormError');
            if(name===''){
                formErrorTipObj.html('收货人不能为空');
                flag = false;
            }else if(!expText.test(name)){
                formErrorTipObj.html('收货人不能有特殊符号');
                flag = false;
            }else if(phone===''){
                formErrorTipObj.html('手机号码不能为空');
                flag = false;
            }else if(!expPhone.test(phone)){
                formErrorTipObj.html('手机号码格式不正确');
                flag = false;
            }else if(address===''){
                formErrorTipObj.html('详细地址不能为空');
                flag = false;
            }else if(!expText.test(address)){
                formErrorTipObj.html('详细地址不能有特殊符号');
                flag = false;
            }else{
                formErrorTipObj.html('');
            }

            return flag;
        },
		/**
         * @function myAddressSubFn 我的地址提交
         */
        myAddressSubFn:function(){
            var _this = this;
            //提交地址按钮
            $('.js_actionSubAddress').click(function(){
                var $this = $(this);
                if($this.attr('data-do')==='yes'&&_this.validateFormFn()){
					var realName = $.trim($('.js_actionNameInput').val());
					var phone = $.trim($('.js_actionPhoneInput').val());
					var address = $.trim($('.js_actionAddressInput').val());
					var expSpace = new RegExp('[ ]{1,}','g');
                    $.ajax({
                        url:postAddressUrl,
                        type:'post',
                        dataType:'json',
                        data:{
                            r:Math.random(),
                            realName:realName.replace(expSpace,''),
                            phone:phone.replace(expSpace,''),
                            address:address.replace(expSpace,'')
                        },
                        beforeSend:function(){
                            $this.attr('data-do','no');
                        },
                        success:function(d){
                            $this.attr('data-do','yes');
                            if(d.status==='success'){
								_this.popFn($('#actionRealPrize'),'close');
								_this.textPopTipFn('提交成功');
                            }else{
                                _this.textPopTipFn(d.message);
                            }
                            
                        },
                        error:function(){
							$this.attr('data-do','yes');
							_this.textPopTipFn('程序小哥困困了！');
                        }
                    });
                }
                
                
            });
		},
		/**
		 * @function textPopTipFn 文本提示弹层
		 * @param text 提示文本
		 */
		textPopTipFn:function(text){
			var _this = this;
			$('.js_actionTip').html(text);
			_this.popFn($('#actionText'),'open');
		},
		/**
		 * @function logOutFn 退出登录
		 */
		logOutFn:function(){
			$('.js_actionLogOut').click(function(){
				global_main.globalFn.logoutFn();
			});
		},
		/**
         * @function formatTimeFn 格式化时间戳
         * @param timestamp 时间戳
         */
        formatTimeFn:function(timestamp){
            var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位不需乘1000
            var Y = date.getFullYear();
            var M = date.getMonth()+1;
            var D = date.getDate();
            var h = (date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours());
            var m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
            var s = date.getSeconds();
            return {
                year:Y,
                month:M,
                day:D,
                hour:h,
                minute:m,
                second:s
            };
		},
		/**
		 * @function popFn 弹层函数
		 * @param obj 弹层对象
		 * @param type 弹层操作类型 init:初始化；open:打开弹层；close:关闭弹层
		 * @param {*} options 弹层配置参数
		 * 
		 */
		popFn:function(obj,type,options){
			if(type==='open'){
				obj.parents('.js_actionPop').show();
			}else if(type==='close'){
				obj.parents('.js_actionPop').hide();
			}else if(type==='init'){
				var defaults = {
					width:'489px',
					height:'439px'
				}
				$.extend(defaults,options);
				var wrapObj = document.createElement('div');
				var popWrapObj = document.createElement('div');
				var closeObj = document.createElement('div');
				var popConObj = document.createElement('div');
				var maskObj = document.createElement('div');
	
				wrapObj.className = 'action_pop_wrap js_actionPop';
				popWrapObj.className = 'action_pop';
				closeObj.className = 'action_pop_close';
				popConObj.className = 'action_pop_con';
				maskObj.className = 'action_pop_mask';
	
				popWrapObj.style.width = parseInt(defaults.width)+'px';
				popWrapObj.style.height = parseInt(defaults.height)+'px';
				popWrapObj.style.marginLeft = -parseInt(defaults.width)/2+'px';
				popWrapObj.style.marginTop = -parseInt(defaults.height)/2+'px';
	
				popConObj.appendChild(obj[0]);
				popWrapObj.appendChild(closeObj);
				popWrapObj.appendChild(popConObj);
				wrapObj.appendChild(popWrapObj);
				wrapObj.appendChild(maskObj);
				
				wrapObj.style.display = 'none';

				document.body.appendChild(wrapObj);
	
				closeObj.onclick = function(){
					wrapObj.style.display = 'none';
				};
			}

		}
	};
	window.daoActions = new DaoActions();
})();
$(function(){
	daoActions.init();
	$('.cbNav').remove();
});